import { cookie } from './cookie.js';

//look for links that go to a different domain than where the user is currently browsing;
//unless that link has the 'no-interstitial' class on it, replace it with a link to the speed bump page
//and store the original URL in a cookie for later use by the speed bump page
function initOffsiteLinks() {
	$('a').each(function () {
		var a = $(this),
			href = a.attr('href'),
			hostname = a.get(0).hostname;

		if (!a.is('.no-interstitial')) {

			if (hostname.length !== 0 && !hostname.endsWith(window.location.hostname)) {
				//a.attr('target', '_self');
				a.data('original-href', href);
				a.attr('href', '/leaving/');
			}
		}
	});

	$('[data-js="speedbump-link"]').each(function () {
		var ocb = cookie('ocb') || {};

		if (ocb && ocb['offsite-url']) {
			$(this).attr('href', ocb['offsite-url']);
		}
	});

	$('body').on('click', 'a', function () {
		var a = $(this),
			href = a.data('original-href');

		if (href) {
			var ocb = cookie('ocb') || {};

			ocb['offsite-url'] = href;

			cookie('ocb', ocb, 60*60*24*365);
			// sessionStorage.setItem('ocb-offsite-link', href);
		}
	});
}

export { initOffsiteLinks };